import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { getAllAdmins, getAdminById, createAdmin, updateAdmin, deleteAdmin } from '../services/adminService';
import Notification from '../components/Common/Notification';

export const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();
  const [admins, setAdmins] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [notification, setNotification] = useState({ message: '', isError: false });

  const fetchAuthHeaders = () => {
    const storedUser = localStorage.getItem('user');
    if (!user && !storedUser) {
      console.error('User or token not available');
      return {};
    }

    const token = user?.token || JSON.parse(storedUser).token;
    return { Authorization: `Bearer ${token}` };
  };

  const showNotification = (message, isError) => {
    setNotification({ message, isError });
  };

  const closeNotification = () => {
    setNotification({ message: '', isError: false });
  };

  const fetchAllAdmins = async () => {
    try {
      const authHeaders = fetchAuthHeaders();
      const data = await getAllAdmins(authHeaders);
      setAdmins(data);
    } catch (error) {
      const errorMessage = error?.response?.data?.error || error?.response?.data?.message || 'Error fetching admins.';
      showNotification(errorMessage, true);
    }
  };

  const fetchAdminById = async (id) => {
    try {
      const authHeaders = fetchAuthHeaders();
      const data = await getAdminById(id, authHeaders);
      setSelectedAdmin(data);
    } catch (error) {
      const errorMessage = error?.response?.data?.error || error?.response?.data?.message || `Error fetching admin with ID ${id}.`;
      showNotification(errorMessage, true);
    }
  };

  // const addAdmin = async (adminData) => {

  //   console.log("data on context ", adminData)
  //   try {
  //     const authHeaders = fetchAuthHeaders();
  //     const newAdmin = await createAdmin(adminData, authHeaders);
  //     setAdmins(prevAdmins => [...prevAdmins, newAdmin]);
  //     showNotification('Admin added successfully!', false);
  //   } catch (error) {
  //     const errorMessage = error.response?.data?.message ||error?.response?.data?.error || error?.response?.error || 'Error adding admin.';
  //     showNotification(errorMessage, true);
  //   }
  // };

  const addAdmin = async (adminData) => {
    console.log("data on context ", adminData);

    // Log the FormData contents
    if (adminData instanceof FormData) {
      for (let pair of adminData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }
    } else {
      console.log("adminData is not FormData");
    }

    try {
      const authHeaders = fetchAuthHeaders();
      const newAdmin = await createAdmin(adminData, authHeaders);
      setAdmins(prevAdmins => [...prevAdmins, newAdmin]);
      showNotification('Admin added successfully!', false);
    } catch (error) {
      const errorMessage = error.response?.data?.message || error?.response?.data?.error || error?.response?.error || 'Error adding admin.';
      showNotification(errorMessage, true);
    }
  };


  const editAdmin = async (id, adminData) => {
    try {
      const authHeaders = fetchAuthHeaders();
      const updatedAdmin = await updateAdmin(id, adminData, authHeaders);
      setAdmins(prevAdmins =>
        prevAdmins.map(admin => (admin.id === id ? updatedAdmin : admin))
      );
      showNotification('Admin updated successfully!', false);
    } catch (error) {
      const errorMessage = error.response?.data.message || error?.response?.data?.message || 'Error updating admin.';
      showNotification(errorMessage, true);
    }
  };

  const removeAdmin = async (id) => {
    try {
      const authHeaders = fetchAuthHeaders();
      await deleteAdmin(id, authHeaders);
      setAdmins(prevAdmins => prevAdmins.filter(admin => admin.id !== id));
      showNotification('Admin removed successfully!', false);
    } catch (error) {
      const errorMessage = error.response?.data?.message || error?.response?.data?.message || 'Error removing admin.';
      showNotification(errorMessage, true);
    }
  };

  // useEffect(() => {
  //   fetchAllAdmins();
  // }, []);


  useEffect(() => {
    if (!isAuthenticated && !['/', '/login'].includes(window.location.pathname)) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);


  return (
    <AdminContext.Provider
      value={{
        admins,
        selectedAdmin,
        fetchAllAdmins,
        fetchAdminById,
        addAdmin,
        editAdmin,
        removeAdmin,
      }}
    >
      {children}
      {notification.message && (
        <Notification
          message={notification.message}
          isError={notification.isError}
          onClose={closeNotification}
        />
      )}
    </AdminContext.Provider>
  );
};
